import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertTriangle, ShieldAlert } from "lucide-react";

// Bug fix v1.4.1: Decode HTML entities from backend sanitization
const decodeHtmlEntities = (str) => {
  if (!str || typeof str !== 'string') return str;
  const textarea = document.createElement('textarea');
  textarea.innerHTML = str;
  return textarea.value;
};

/**
 * SpamFlags component - displays detected spam tactics with warning styling
 * Added in v1.1.0 for spam detection feature
 */
export const SpamFlags = ({ flags }) => {
  // Only render if there are spam flags
  if (!flags || !Array.isArray(flags) || flags.length === 0) return null;

  return (
    <Card className="border-destructive/50 bg-destructive/5 shadow-md">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg font-semibold flex items-center gap-2 text-destructive">
          <ShieldAlert className="h-5 w-5" />
          Spam Flags Detected
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <p className="text-sm text-muted-foreground mb-3">
            The following spam indicators were found in your post:
          </p>
          <ul className="space-y-2">
            {flags.map((flag, index) => (
              <li 
                key={index} 
                className="flex items-start gap-2 text-sm text-red-900 font-medium"
              >
                <AlertTriangle className="h-4 w-4 text-destructive mt-0.5 flex-shrink-0" />
                <span>{decodeHtmlEntities(flag)}</span>
              </li>
            ))}
          </ul>
          <p className="text-xs text-muted-foreground mt-4 pt-3 border-t border-destructive/20">
            Posts with spam tactics receive lower scores. Consider removing these elements for better results.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default SpamFlags;
